export const ALL_COLUMNS_ID = 'all-columns';
export const SELECTED_COLUMNS_ID = 'selected-columns';
